module.exports = __webpack_public_path__ + "img/v3.d3b0b78b.png";